import { render } from "./MWWebCategories.vue?vue&type=template&id=3f2cddfe"
import script from "./MWWebCategories.vue?vue&type=script&lang=js"
export * from "./MWWebCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__